<template>
  <input 
    :type="fieldType" 
    :value="modelValue" 
    @input="$emit('update:modelValue', $event.target.value)" 
    :placeholder="placeholder" 
    :class="(hasError ? 'has-error': '', $i18n.locale === 'ar' ? 'arabic-text' : '')"
    :required="isRequiredValue"
    :disabled="isDisabled"
  />

</template>

<script>
export default {
  name: 'TextInputField',
  props: {
    modelValue: {
      type: String,
      required: true
    },
    placeholder: {
      type: String
    },
    fieldType: {
      type: String,
      default: "text"
    },
    isRequiredValue: {
      type: Boolean,
      default: false
    },
    hasError: {
      type: Boolean,
      default: false
    },
    isDisabled: {
      type: Boolean,
      default: false
    }
  }
};
</script>

<style scoped>
input {
  width: 100%;
  padding: 0.55rem;
  border-radius: 8px;
  border: 1px solid #ccc;
  outline: none;
  line-height: 0;
}
input::placeholder {
  color: #020076; /* Your desired color */
}
input.arabic-text::placeholder {
  text-align: right; /* Align placeholder to the right */
  direction: rtl;    /* Force placeholder direction */
}

input.arabic-text {
  direction: ltr;    /* Keep input text typed by user on the left */
  text-align: left;  /* Ensure user input starts from the left */
}
</style>
